import { Column } from '../../../../components/Table/Column';

const columnsMobile: Column[] = [{
  key: 'name',
  align: 'left',
  size: 9,
}];

export default columnsMobile;
